export default __webpack_public_path__ + "static/media/octadmin-icon.754fc2a8.svg";